import React, { useState } from "react";
import ContactSection from "./ContactSection";

type TabType = {
  name: string;
  img: string;
};

const tabs: TabType[] = [
  { name: "Facebook", img: "./images/facebook.jpeg" },
  { name: "Instagram", img: "./images/instagram.jpeg" },
  { name: "YouTube", img: "./images/google.jpeg" },
  { name: "WhatsApp", img: "./images/whatsapp.jpg" },
];

const ProductLanding: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<string>("Facebook");
  const [phone, setPhone] = useState<string>("");
  const [viewImage, setViewImage] = useState<string | null>(null); // ✅ moved here

  const handleWhatsApp = () => {
    if (!phone) {
      alert("Please enter your phone number");
      return;
    }
    const message = encodeURIComponent(
      `Hello, please call me back. My number is ${phone}`
    );
    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
  };

  return (
    <div className="bg-black py-16 px-4">
      {/* Heading */}
      <h2 className="text-center text-3xl md:text-4xl font-bold text-yellow-500 mb-14">
        Our Social Media Links
      </h2>

      {/* SOCIAL IMAGE SECTION */}
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 mb-16">
        {tabs.map((tab) => (
          <div
            key={tab.name}
            onClick={() => {
              setSelectedTab(tab.name);
              setViewImage(tab.img);
            }}
            className={`relative cursor-pointer overflow-hidden transition-all duration-500
              ${selectedTab === tab.name ? "ring-4 ring-yellow-400 z-10" : ""}`}
          >
            {/* IMAGE */}
            <img
              src={tab.img}
              alt={tab.name}
              className="w-full h-[60vh] sm:h-[70vh] lg:h-[80vh] object-cover hover:scale-110 transition duration-700"
            />

            {/* OVERLAY */}
            <div className="absolute inset-0 bg-black/10 hover:bg-black/50 transition"></div>

            {/* TEXT */}
            <div className="absolute bottom-0 w-full text-center py-4 bg-black/80">
              <p className="text-white text-xl font-bold tracking-wide">
                {tab.name}
              </p>
            </div>

            {/* ACTIVE LABEL */}
            {selectedTab === tab.name && (
              <div className="absolute top-4 right-4 bg-yellow-400 text-black px-4 py-1 rounded-full text-sm font-bold">
                Active
              </div>
            )}
          </div>
        ))}
      </div>

      {/* IMAGE VIEW MODAL */}
      {viewImage && (
        <div
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
          onClick={() => setViewImage(null)}
        >
          <img
            src={viewImage}
            alt="Preview"
            className="max-w-full max-h-full rounded-xl shadow-2xl animate-zoom"
          />
        </div>
      )}

      {/* Left Side - Enquiry Form */}
            <ContactSection/>
       {/* Left Side - Enquiry Form */}

     </div>
  );
};

export default ProductLanding;
